import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
//import banner from '../../images/banner_bigScreen2.PNG'
import knapper from '../../../images/Knapper_logo_full.png'
import usabh_logo from '../../../images/usabh_logo.png'
import clubs_logo from '../../../images/ClubChampionships.png'
import clubs_logo_knapper from '../../../images/clubsKnapper_transparent.png'
import './Banner.css'

const Banner = () => {
	return (
		<a
			className='bannerLink'
			href='https://knapperusa.com/'
			target='_blank'
			rel='noopener noreferrer'
		>
			<img
				src={clubs_logo_knapper}
				className='banner'
				alt='Clubs Championships'
			/>
		</a>
	)
}

export default Banner
